var map = {
	"./de/group-logo.png": "Wy3X",
	"./en/group-logo.png": "jz/V",
	"./es/group-logo.png": "vZvy",
	"./fr/group-logo.png": "b+kC",
	"./ja/group-logo.png": "ePV6",
	"./ko/group-logo.png": "Ju5H",
	"./pt/group-logo.png": "jjib",
	"./ru/group-logo.png": "4iZL",
	"./tc/group-logo.png": "Tcao",
	"./th/group-logo.png": "mXMT"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ydIV";